module.exports = __webpack_public_path__ + "static/media/52822948_2452976194777557_2845563683554197504_o.8e14bfe2.jpg";